import styled from 'styled-components'

export const Form = styled.form`
    max-width: 220px;
    width:inherit;
    margin: 20px auto;
     /*mobile version
  @media (max-width: 1100px) {
    display:${props => props.facebook && "none"};
    display:${props => props.google && "none"};
  }
     */
`